import { BoxProps } from "@mui/system"
import React from "react"
import { Box, Typography } from "src/UILibrary"

type Props = {
  selected: number
  tabs: string[]
  handleTab: any
}

export const MemberTab = ({ selected, tabs, handleTab }: Props) => {
  return (
    <Box display="flex">
      {tabs.map((tab, index) => {
        let sx: BoxProps = {
          width: "180px",
          height: "50px",
        }

        if (index + 1 === selected) {
          sx = { ...sx, bgcolor: "#FAFAFA", borderTop: "2px solid #1F6757" }
        }
        return (
          <Box
            display="flex"
            key={index}
            sx={{ ...sx, ":hover": { opacity: 0.8, cursor: "pointer" } }}
            onClick={() => handleTab(index + 1)}
          >
            <Typography.Stepper
              sx={{
                fontFamily: "Noto Sans !important",
                fontWeight: "700",
                ml: "20px",
                my: "auto",
              }}
            >
              {tab}
            </Typography.Stepper>
          </Box>
        )
      })}
    </Box>
  )
}
